/*
 * @Description: 跳转按钮
 * @Author: zhongshanxian01
 * @Date: 2021-05-25 10:52:29
 * @LastEditors: zhongshanxian01
 * @LastEditTime: 2022-01-21 11:15:56
 */
import { setUrlParams } from '@utils/filters';
import baseInfo, { ztInitInfo } from '@stores/index.js';
import setLog from '@utils/log';
import React from 'react';
import { catchable } from '@components/catchable';

let curTop = 0; // 当前滚动高度
let goTop = 0; // 目标滚动高度

function scrollAnimationFun() {
    if (curTop === goTop) return;
    if (Math.abs(curTop - goTop) < 80) {
        curTop = goTop;
    } else if (curTop > goTop) {
        curTop -= 80;
    } else {
        curTop += 80;
    }
    window.scrollTo(window.scrollX, curTop);
    window.requestAnimationFrame(() => {
        scrollAnimationFun();
    });
}
function targetModule(id) {
    curTop = window.scrollY;
    if (id && baseInfo.pageItemScrollTop[id] != undefined) {
        goTop = baseInfo.pageItemScrollTop[id];
        window.requestAnimationFrame(() => {
            scrollAnimationFun();
        });
    }
}
export function applyClickFun(event, btnItem, moduleName, moduleId, pcOpenMode) {
    event.preventDefault();

    setLog.set({
        id: 'clk_web_106_1',
        info: {
            link_url: setUrlParams(ztInitInfo.params, btnItem.url),
            module_name: moduleName,
            module_id: moduleId,
            botton_name: btnItem.button_name
        }
    });
    if (btnItem.url.indexOf('#') == 0) {
        let id = btnItem.url.slice(1);
        targetModule(id);
    } else if (pcOpenMode == 'this') {
        window.location.href = setUrlParams(ztInitInfo.params, btnItem.url);
    } else {
        window.open(setUrlParams(ztInitInfo.params, btnItem.url));
    }
}

function ApplyButton(props) {
    const { applyButtonInfo, pcOpenMode } = props;
    return (
        <div className="apply-btn-group">
            {applyButtonInfo.content.map((btnItem, btnIndex) => {
                return (
                    <a
                        key={'applyBtn' + btnIndex}
                        className={`apply-btn apply-btn${btnIndex + 1}`}
                        target={pcOpenMode == 'this' ? '_self' : '_blank'}
                        onClick={(event) => {
                            applyClickFun(
                                event,
                                btnItem,
                                applyButtonInfo.module_name,
                                applyButtonInfo.id,
                                pcOpenMode
                            );
                        }}
                    >
                        <img className="apply-bg-common" src={btnItem.button_common} alt="" />
                        <img className="apply-bg-active" src={btnItem.button_click} alt="" />
                    </a>
                );
            })}
        </div>
    );
}

export default catchable(ApplyButton);
